import config from "../../../utils/settings";

export default {
  CREATE_FOLDER: () => `${config.REACT_APP_BASE_URL}/folder`,
};
